/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
/* !!!! DO NOT EDIT THE FILE MANUALLY !!! */
/* !!!!!!!!! AUTO GENERATED FILE !!!!!!!! */
/* !!!!!! USE: npm run update:icons !!!!! */
/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */
import AclNamespaceMap from '../../assets/img/svg/icons/acl-namespace-map.svg';
import AclNamespace from '../../assets/img/svg/icons/acl-namespace.svg';
import AclObject from '../../assets/img/svg/icons/acl-object.svg';
import AngleDoubleLeft from '../../assets/img/svg/icons/angle-double-left.svg';
import AngleDoubleRight from '../../assets/img/svg/icons/angle-double-right.svg';
import AngleDown from '../../assets/img/svg/icons/angle-down.svg';
import AngleLeft from '../../assets/img/svg/icons/angle-left.svg';
import AngleRight from '../../assets/img/svg/icons/angle-right.svg';
import AngleUp from '../../assets/img/svg/icons/angle-up.svg';
import ArrowFromBottm from '../../assets/img/svg/icons/arrow-from-bottm.svg';
import ArrowFromBottom from '../../assets/img/svg/icons/arrow-from-bottom.svg';
import ArrowFromTop from '../../assets/img/svg/icons/arrow-from-top.svg';
import ArrowRightFromSquare from '../../assets/img/svg/icons/arrow-right-from-square.svg';
import ArrowToBottm from '../../assets/img/svg/icons/arrow-to-bottm.svg';
import ArrowToBottom from '../../assets/img/svg/icons/arrow-to-bottom.svg';
import ArrowToTop from '../../assets/img/svg/icons/arrow-to-top.svg';
import At from '../../assets/img/svg/icons/at.svg';
import Ban from '../../assets/img/svg/icons/ban.svg';
import Book from '../../assets/img/svg/icons/book.svg';
import CalendarAlt from '../../assets/img/svg/icons/calendar-alt.svg';
import ChaosReplicatedTable from '../../assets/img/svg/icons/chaos-replicated-table.svg';
import ChartBar from '../../assets/img/svg/icons/chart-bar.svg';
import ChartLine from '../../assets/img/svg/icons/chart-line.svg';
import Chart_line from '../../assets/img/svg/icons/chart_line.svg';
import CheckCircle from '../../assets/img/svg/icons/check-circle.svg';
import Check from '../../assets/img/svg/icons/check.svg';
import ChevronDown from '../../assets/img/svg/icons/chevron-down.svg';
import ChevronUp from '../../assets/img/svg/icons/chevron-up.svg';
import Circle from '../../assets/img/svg/icons/circle.svg';
import ClipboardList from '../../assets/img/svg/icons/clipboard-list.svg';
import Clock from '../../assets/img/svg/icons/clock.svg';
import Clone from '../../assets/img/svg/icons/clone.svg';
import Cloud from '../../assets/img/svg/icons/cloud.svg';
import CodeBranch from '../../assets/img/svg/icons/code-branch.svg';
import CodeMerge from '../../assets/img/svg/icons/code-merge.svg';
import Cog from '../../assets/img/svg/icons/cog.svg';
import Cogs from '../../assets/img/svg/icons/cogs.svg';
import Compress from '../../assets/img/svg/icons/compress.svg';
import Copy from '../../assets/img/svg/icons/copy.svg';
import Digging from '../../assets/img/svg/icons/digging.svg';
import Download from '../../assets/img/svg/icons/download.svg';
import DynTh from '../../assets/img/svg/icons/dyn-th.svg';
import EllipsisH from '../../assets/img/svg/icons/ellipsis-h.svg';
import Eraser from '../../assets/img/svg/icons/eraser.svg';
import ExclamationCircle from '../../assets/img/svg/icons/exclamation-circle.svg';
import ExclamationTriangle from '../../assets/img/svg/icons/exclamation-triangle.svg';
import Exclamation from '../../assets/img/svg/icons/exclamation.svg';
import Expand from '../../assets/img/svg/icons/expand.svg';
import ExternalLink from '../../assets/img/svg/icons/external-link.svg';
import EyeSlash from '../../assets/img/svg/icons/eye-slash.svg';
import Eye from '../../assets/img/svg/icons/eye.svg';
import FileAlt from '../../assets/img/svg/icons/file-alt.svg';
import FileExport from '../../assets/img/svg/icons/file-export.svg';
import File from '../../assets/img/svg/icons/file.svg';
import Filter from '../../assets/img/svg/icons/filter.svg';
import Flame from '../../assets/img/svg/icons/flame.svg';
import FolderOpen from '../../assets/img/svg/icons/folder-open.svg';
import FolderTree from '../../assets/img/svg/icons/folder-tree.svg';
import Folder from '../../assets/img/svg/icons/folder.svg';
import Folders from '../../assets/img/svg/icons/folders.svg';
import Ghost from '../../assets/img/svg/icons/ghost.svg';
import HandPaper from '../../assets/img/svg/icons/hand-paper.svg';
import Hashtag from '../../assets/img/svg/icons/hashtag.svg';
import Intersection from '../../assets/img/svg/icons/intersection.svg';
import Key from '../../assets/img/svg/icons/key.svg';
import LayoutColumns3 from '../../assets/img/svg/icons/layout-columns-3.svg';
import LevelDownAlt from '../../assets/img/svg/icons/level-down-alt.svg';
import Link from '../../assets/img/svg/icons/link.svg';
import List from '../../assets/img/svg/icons/list.svg';
import NotSuported from '../../assets/img/svg/icons/not-suported.svg';
import PauseCircle from '../../assets/img/svg/icons/pause-circle.svg';
import PencilAlt from '../../assets/img/svg/icons/pencil-alt.svg';
import Pencil from '../../assets/img/svg/icons/pencil.svg';
import Plane from '../../assets/img/svg/icons/plane.svg';
import PlayCircle from '../../assets/img/svg/icons/play-circle.svg';
import Plus from '../../assets/img/svg/icons/plus.svg';
import PollPeople from '../../assets/img/svg/icons/poll-people.svg';
import QuestionCircle from '../../assets/img/svg/icons/question-circle.svg';
import Redo from '../../assets/img/svg/icons/redo.svg';
import ReplicationLogTable from '../../assets/img/svg/icons/replication-log-table.svg';
import Rocket from '../../assets/img/svg/icons/rocket.svg';
import Save from '../../assets/img/svg/icons/save.svg';
import Share from '../../assets/img/svg/icons/share.svg';
import Snowflake from '../../assets/img/svg/icons/snowflake.svg';
import SortAlt from '../../assets/img/svg/icons/sort-alt.svg';
import SortAmountDownAlt from '../../assets/img/svg/icons/sort-amount-down-alt.svg';
import SortAmountUp from '../../assets/img/svg/icons/sort-amount-up.svg';
import SortDown from '../../assets/img/svg/icons/sort-down.svg';
import SortUp from '../../assets/img/svg/icons/sort-up.svg';
import Sort from '../../assets/img/svg/icons/sort.svg';
import StarAlt from '../../assets/img/svg/icons/star-alt.svg';
import Star from '../../assets/img/svg/icons/star.svg';
import StopCircle from '../../assets/img/svg/icons/stop-circle.svg';
import SyncAlt from '../../assets/img/svg/icons/sync-alt.svg';
import Table from '../../assets/img/svg/icons/table.svg';
import QueueTable from '../../assets/img/svg/icons/queue-table.svg';
import Tag from '../../assets/img/svg/icons/tag.svg';
import Tasks from '../../assets/img/svg/icons/tasks.svg';
import Th from '../../assets/img/svg/icons/th.svg';
import Times from '../../assets/img/svg/icons/times.svg';
import TrashAlt from '../../assets/img/svg/icons/trash-alt.svg';
import TrashBin from '../../assets/img/svg/icons/trash-bin.svg';
import Triangle from '../../assets/img/svg/icons/triangle.svg';
import Undo from '../../assets/img/svg/icons/undo.svg';
import Union from '../../assets/img/svg/icons/union.svg';
import Unlink from '../../assets/img/svg/icons/unlink.svg';
import Upload from '../../assets/img/svg/icons/upload.svg';
import User from '../../assets/img/svg/icons/user.svg';
import WeightHanging from '../../assets/img/svg/icons/weight-hanging.svg';
import WindowMaximize from '../../assets/img/svg/icons/window-maximize.svg';
export const autoIcons = {
    ['acl-namespace-map']: AclNamespaceMap,
    ['acl-namespace']: AclNamespace,
    ['acl-object']: AclObject,
    ['angle-double-left']: AngleDoubleLeft,
    ['angle-double-right']: AngleDoubleRight,
    ['angle-down']: AngleDown,
    ['angle-left']: AngleLeft,
    ['angle-right']: AngleRight,
    ['angle-up']: AngleUp,
    ['arrow-from-bottm']: ArrowFromBottm,
    ['arrow-from-bottom']: ArrowFromBottom,
    ['arrow-from-top']: ArrowFromTop,
    ['arrow-right-from-square']: ArrowRightFromSquare,
    ['arrow-to-bottm']: ArrowToBottm,
    ['arrow-to-bottom']: ArrowToBottom,
    ['arrow-to-top']: ArrowToTop,
    ['at']: At,
    ['ban']: Ban,
    ['book']: Book,
    ['calendar-alt']: CalendarAlt,
    ['chaos-replicated-table']: ChaosReplicatedTable,
    ['chart-bar']: ChartBar,
    ['chart-line']: ChartLine,
    ['chart_line']: Chart_line,
    ['check-circle']: CheckCircle,
    ['check']: Check,
    ['chevron-down']: ChevronDown,
    ['chevron-up']: ChevronUp,
    ['circle']: Circle,
    ['clipboard-list']: ClipboardList,
    ['clock']: Clock,
    ['clone']: Clone,
    ['cloud']: Cloud,
    ['code-branch']: CodeBranch,
    ['code-merge']: CodeMerge,
    ['cog']: Cog,
    ['cogs']: Cogs,
    ['compress']: Compress,
    ['copy']: Copy,
    ['digging']: Digging,
    ['download']: Download,
    ['dyn-th']: DynTh,
    ['ellipsis-h']: EllipsisH,
    ['eraser']: Eraser,
    ['exclamation-circle']: ExclamationCircle,
    ['exclamation-triangle']: ExclamationTriangle,
    ['exclamation']: Exclamation,
    ['expand']: Expand,
    ['external-link']: ExternalLink,
    ['eye-slash']: EyeSlash,
    ['eye']: Eye,
    ['file-alt']: FileAlt,
    ['file-export']: FileExport,
    ['file']: File,
    ['filter']: Filter,
    ['flame']: Flame,
    ['folder-open']: FolderOpen,
    ['folder-tree']: FolderTree,
    ['folder']: Folder,
    ['folders']: Folders,
    ['ghost']: Ghost,
    ['hand-paper']: HandPaper,
    ['hashtag']: Hashtag,
    ['intersection']: Intersection,
    ['key']: Key,
    ['layout-columns-3']: LayoutColumns3,
    ['level-down-alt']: LevelDownAlt,
    ['link']: Link,
    ['list']: List,
    ['not-suported']: NotSuported,
    ['pause-circle']: PauseCircle,
    ['pencil-alt']: PencilAlt,
    ['pencil']: Pencil,
    ['plane']: Plane,
    ['play-circle']: PlayCircle,
    ['plus']: Plus,
    ['poll-people']: PollPeople,
    ['question-circle']: QuestionCircle,
    ['redo']: Redo,
    ['replication-log-table']: ReplicationLogTable,
    ['rocket']: Rocket,
    ['save']: Save,
    ['share']: Share,
    ['snowflake']: Snowflake,
    ['sort-alt']: SortAlt,
    ['sort-amount-down-alt']: SortAmountDownAlt,
    ['sort-amount-up']: SortAmountUp,
    ['sort-down']: SortDown,
    ['sort-up']: SortUp,
    ['sort']: Sort,
    ['star-alt']: StarAlt,
    ['star']: Star,
    ['stop-circle']: StopCircle,
    ['sync-alt']: SyncAlt,
    ['table']: Table,
    ['queue-table']: QueueTable,
    ['tag']: Tag,
    ['tasks']: Tasks,
    ['th']: Th,
    ['times']: Times,
    ['trash-alt']: TrashAlt,
    ['trash-bin']: TrashBin,
    ['triangle']: Triangle,
    ['undo']: Undo,
    ['union']: Union,
    ['unlink']: Unlink,
    ['upload']: Upload,
    ['user']: User,
    ['weight-hanging']: WeightHanging,
    ['window-maximize']: WindowMaximize,
};
